export type CamaraStreamVideo = {
  video_id: string;
  youtube_id: string;
  title: string;
  instructor: string;
  duration: string;
  level: 'Inicial' | 'Intermedio' | 'Avanzado';
  category: 'Ventas' | 'Marketing' | 'Gestión' | 'IA';
  activo: boolean;
};

const STORAGE_KEY = 'camara_stream_videos';
const STORAGE_VERSION_KEY = 'camara_stream_videos_version';
const STORAGE_VERSION = '2026-03-ecommerce-es';

const defaults: CamaraStreamVideo[] = [
  { video_id: '1', youtube_id: 'oUFJJNQGwhk', title: 'Cómo sacar fotos de producto con celular (luz y fondo)', instructor: 'Cámara Stream', duration: '11:42', level: 'Inicial', category: 'Marketing', activo: true },
  { video_id: '2', youtube_id: 'n0j0lO9h8iY', title: 'Ecommerce para comercios locales: primeros pasos', instructor: 'Equipo Cámara', duration: '17:08', level: 'Inicial', category: 'Ventas', activo: true },
  { video_id: '3', youtube_id: 'QhBnZ6NPOY0', title: 'Cómo redactar descripciones que venden productos', instructor: 'Mentoría Comercial', duration: '13:25', level: 'Intermedio', category: 'Ventas', activo: true },
  { video_id: '4', youtube_id: 'u31qwQUeGuM', title: 'Publicar productos en redes: formato, precio y CTA', instructor: 'Cámara Stream', duration: '15:10', level: 'Intermedio', category: 'Marketing', activo: true },
  { video_id: '5', youtube_id: 'M7lc1UVf-VE', title: 'Cómo organizar catálogo, stock y precios sin caos', instructor: 'Gestión PyME', duration: '19:40', level: 'Intermedio', category: 'Gestión', activo: true },
  { video_id: '6', youtube_id: 'ysz5S6PUM-U', title: 'Ideas con IA para títulos, copies y fichas de producto', instructor: 'Lab Innovación', duration: '14:55', level: 'Avanzado', category: 'IA', activo: true },
];

const read = (): CamaraStreamVideo[] => {
  const currentVersion = localStorage.getItem(STORAGE_VERSION_KEY);
  if (currentVersion !== STORAGE_VERSION) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(defaults));
    localStorage.setItem(STORAGE_VERSION_KEY, STORAGE_VERSION);
    return defaults;
  }

  const raw = localStorage.getItem(STORAGE_KEY);
  if (!raw) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(defaults));
    return defaults;
  }
  try {
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : defaults;
  } catch {
    return defaults;
  }
};

const write = (videos: CamaraStreamVideo[]) => {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(videos));
};

export const getCamaraStreamVideos = async () => read();

export const createCamaraStreamVideo = async (payload: Omit<CamaraStreamVideo, 'video_id'>) => {
  const videos = read();
  const created: CamaraStreamVideo = { ...payload, video_id: String(Date.now()) };
  write([created, ...videos]);
  return created;
};

export const updateCamaraStreamVideo = async (video_id: string, payload: Partial<CamaraStreamVideo>) => {
  const videos = read().map((v) => (v.video_id === video_id ? { ...v, ...payload } : v));
  write(videos);
  return videos.find((v) => v.video_id === video_id);
};

export const deleteCamaraStreamVideo = async (video_id: string) => {
  const videos = read().filter((v) => v.video_id !== video_id);
  write(videos);
};
